export default {
  getHistory: ({history}) => history,
  getLastHistory: ({history}) => history[history.length - 1],
}
